import Constant from "../../Constants/Constants";

class Maintenance {
  static GetMaintenanceHistoryRequest = (payload) => ({
    type: Constant.GET_MAINTENANCE_HISTORY_REQUEST,
    payload,
  });

  static GetMaintenanceHistorySuccess = (data) => ({
    type: Constant.GET_MAINTENANCE_HISTORY_SUCCESS,
    payload: data,
  });

  static GetMaintenanceHistoryFailure = (error) => ({
    type: Constant.GET_MAINTENANCE_HISTORY_FAILURE,
    payload: error,
  });

  static SubmitMaintenanceRequest = (payload) => ({
    type: Constant.SUBMIT_MAINTENANCE_REQUEST,
    payload,
  });

  static SubmitMaintenanceSuccess = (data) => ({
    type: Constant.SUBMIT_MAINTENANCE_SUCCESS,
    payload: data,
  });

  static SubmitMaintenanceFailure = (error) => ({
    type: Constant.SUBMIT_MAINTENANCE_FAILURE,
    payload: error,
  });

  static CancelMaintenanceRequest = (payload) => ({
    type: Constant.CANCEL_MAINTENANCE_REQUEST,
    payload,
  });

  static CancelMaintenanceSuccess = (data) => ({
    type: Constant.CANCEL_MAINTENANCE_SUCCESS,
    payload: data,
  });

  static CancelMaintenanceFailure = (error) => ({
    type: Constant.CANCEL_MAINTENANCE_FAILURE,
    payload: error,
  });
}

export default Maintenance;
